import React from "react";
import { Card, Button } from "react-onsenui";
import ReactionItem from "./ReactionItem";
import TutorialCarousel from "../TutorialCarousel";
import { getReagent } from "../../services/megamix";

// const TutorialImage1 = require(`../../assets/Tutorial/pictogramy_apka2_r.webp`).default
// const TutorialImage2 = require(`../../assets/Tutorial/pictogramy_apka2.webp`).default

const style = {
  helpCard: {
    textAlign: "center",
    marginTop: '15px'
  },
  reactionsContainer: {
    marginBottom: 0,
    padding: 20
  },
  reactionsTable: {
    width: "100%"
  }
};



export default class ReactionsList extends React.Component {

  handleCounterInfoClick = () => {
    alert("Number count on each reaction represents the number of all compounds known to have similar end result of color change reaction with particular reagent.");
  };  


  renderInfo() {
    const { reactions, queries } = this.props;
    if (queries.length === 0 && reactions.length === 0) {
      return <div />;
      // return (
      //   <div>
      //     {/* <Card style={style.helpCard}>
      //       Tap blue button, then pick reagent and reaction colors
      //     </Card> */}
      //     <div style={{ marginTop: "50px" }}>
      //       {/* <TutorialCarousel finishLabel="Tap the search button below to start!" /> */}
      //       <img src={TutorialImage1} className="testdrugs-tutorial-image" />
      //       <img src={TutorialImage2} className="testdrugs-tutorial-image" />
      //     </div>
      //   </div>
      // );
    }
    if (queries.length > 0 && reactions.length === 0) {
      return (
        <Card style={style.helpCard}>
          No matching substances found
        </Card>
      );
    }
    return (
      <Card style={style.helpCard}>
        Found {`${reactions.length}`} matching substances
        <div onClick={this.handleCounterInfoClick} style={{ display: 'inline', cursor: 'pointer' }}>
          <i className="zmdi zmdi-info-outline" style={{ marginLeft: '10px' }}></i>
        </div>
      </Card>
    );
    
  }

  getFilteredReactions(isPopular) {
    const { reactions } = this.props;
    return reactions.filter(r => r.substance.isPopular === isPopular);
  }

  renderReaction(reaction) {
    return <ReactionItem
        key={reaction.substance.id}
        results={reaction.results}
        substance={reaction.substance}
        navigator={this.props.navigator}
        queries={this.props.queries}
        NoOnsen={this.props.NoOnsen}
      />;
  }

  renderListHeader(queries, reactions) {
    if (reactions.length < 1) {
      return <div></div>;
    }

    let reagentBlobs = []
    // queries.map((query, index) => {
    //   const text = getReagent(query.reagentId).shortName;
    //   reagentBlobs.push(
    //   <div key={index} className="testdrugs-reaction-color-circles">
    //       <div className="reagent-name">
    //         {text}
    //       </div>
    //   </div>
    //   );
    // })
    queries
    .slice() // Create a copy of the array to avoid mutating props
    .sort((a, b) => a.reagentId - b.reagentId) // Sort by reagentId
    .map((query, index) => {
      const text = getReagent(query.reagentId).shortName;
      reagentBlobs.push(
        <div key={index} className="testdrugs-reaction-color-circles">
          <div className="reagent-name">{text}</div>
        </div>
      );
    })  

    return (
      <div className="testdrugs-reactions-reaction testdrugs-reactions-list-header">
        <div className="testdrugs-reaction-header">
          <div className="testdrugs-reaction-name">
          </div>

          <div className="testdrugs-reaction-colors">
            {reagentBlobs}
          </div>
        </div>
      </div>
    );
  }

  render() {
    const { queries } = this.props;
    const popularReactions = this.getFilteredReactions(true);
    const otherReactions = this.getFilteredReactions(false);

    return (
      <div style={style.reactionsContainer}>

        {this.renderInfo()}

        <h3 style={{ marginTop: '30px' }}>Common substances ({"" + popularReactions.length})</h3>
        <div className="testdrugs-reactions-container">
          {this.renderListHeader(queries, popularReactions)}
          {popularReactions.map(reaction => this.renderReaction(reaction))}
        </div>

        <h3 style={{ marginTop: '25px' }}>Other substances ({""+otherReactions.length})</h3>
        <div className="testdrugs-reactions-container">
          {this.renderListHeader(queries, otherReactions)}
          {otherReactions.map(reaction => this.renderReaction(reaction))}
        </div>
      </div>
    );
  }
}
